import { useState, useCallback } from 'react';
import {
  useStripe,
  useElements,
  AddressElement,
  PaymentElement,
} from '@stripe/react-stripe-js';

import { Button, BUTTON_SIZE, BUTTON_TYPE } from '../../Button';
import {
  ROUTE_MEMBERSHIP_PAYMENT_METHOD,
  MEMBERSHIP_CONFIRM_PARAM,
} from '../../../config/routes';
import { TRASHIE_GOOGLE_MAPS_API_KEY } from '../../../config/config';
import { getConfig } from '../../../../../config/config';

import './PaymentMethodForm.scss';

// Must be used inside stripe's Elements component
const PaymentMethodForm = ({ onCancel }) => {
  const stripe = useStripe();
  const elements = useElements();

  const [ready, setReady] = useState(false);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);

  const handleSaveCard = useCallback(async () => {
    if (!stripe || !elements) {
      return;
    }

    setSaving(true);

    const {
      error: confirmError,
    } = await stripe.confirmSetup({
      elements,
      confirmParams: {
        return_url: `${getConfig('BASE_URL_TRASHIE')}${ROUTE_MEMBERSHIP_PAYMENT_METHOD}?${MEMBERSHIP_CONFIRM_PARAM}=true`,
      },
    });

    if (confirmError) {
      setError(confirmError.message);
      setSaving(false);
      return;
    }

    setError(null);
    setSaving(false);
  }, [stripe, elements]);

  return (
    <div className="PaymentMethodForm">
      <PaymentElement onReady={() => setReady(true)} />
      <AddressElement
        options={{
          mode: 'billing',
          allowedCountries: ['US', 'CO'],
          autocomplete: {
            mode: 'google_maps_api',
            apiKey: TRASHIE_GOOGLE_MAPS_API_KEY,
          },
        }}
      />
      <div className="PaymentMethodForm__error">
        {error}
      </div>
      <Button
        type={BUTTON_TYPE.QUATERNARY}
        size={BUTTON_SIZE.LARGE}
        onClick={handleSaveCard}
        disabled={!stripe || !elements || !ready || saving}
      >
        Save
      </Button>
      {onCancel && (
        <Button
          type={BUTTON_TYPE.QUINARY}
          size={BUTTON_SIZE.LARGE}
          onClick={onCancel}
          disabled={!stripe || !elements || !ready || saving}
        >
          Cancel
        </Button>
      )}
    </div>
  );
};

export default PaymentMethodForm;
